import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { posApi } from '@/lib/api';

const PosAuthContext = createContext(null);

export function PosAuthProvider({ children }) {
  const [posStaff, setPosStaff] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem('tiffin_pos_token');
    if (!token) {
      setPosStaff(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await posApi.get('/pos/me');
      setPosStaff(data.staff);
    } catch {
      localStorage.removeItem('tiffin_pos_token');
      setPosStaff(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const loginWithPin = async (pin) => {
    const { data } = await posApi.post('/pos/pin-login', { pin });
    localStorage.setItem('tiffin_pos_token', data.token);
    setPosStaff(data.staff);
    return data.staff;
  };

  const lock = () => {
    localStorage.removeItem('tiffin_pos_token');
    setPosStaff(null);
  };

  return (
    <PosAuthContext.Provider value={{ posStaff, loading, loginWithPin, lock }}>
      {children}
    </PosAuthContext.Provider>
  );
}

export const usePosAuth = () => useContext(PosAuthContext);
